import { FC } from 'react';

import { Currency } from '@/constants';

import UtxoSelectModal, { type UtxoSelectModalProps } from '../UtxoSelectModal';

import { useBtcLikeUtxosSelect } from './useBtcLikeUtxosSelect';

type Props = Omit<
  UtxoSelectModalProps,
  'confirmedUtxos' | 'unconfirmedUtxos' | 'selectedUtxos' | 'toggleUtxo' | 'resetUtxos'
> & {
  address: string | null;
};

const BtcLikeUtxoSelectModal: FC<Props> = ({ address, ...props }) => {
  const { confirmedUtxos, unconfirmedUtxos, selectedUtxos, toggleUtxo, resetUtxos } = useBtcLikeUtxosSelect(
    props.currency,
    address
  );

  return (
    <UtxoSelectModal
      {...props}
      confirmedUtxos={confirmedUtxos}
      unconfirmedUtxos={unconfirmedUtxos}
      selectedUtxos={selectedUtxos}
      toggleUtxo={toggleUtxo}
      resetUtxos={resetUtxos}
      currency={Currency.BTC}
    />
  );
};

export default BtcLikeUtxoSelectModal;
